import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-push-finished-card',
  templateUrl: './push-finished.component.html',
  styleUrls: ['./push-finished.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PushFinishedComponent {
  @Input() status: string;
  @Input() siteId: string;

  constructor(private router: Router) {}

  goToOverview(): void {
    this.router.navigateByUrl(`/site/${this.siteId}/overview`);
  }
}
